﻿import { DatePicker } from '@fluentui/react-datepicker-compat';

export class DateP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MotivoRechazo: 'Selecciona una causal de rechazo',
      DateSelected: false,
      showInput: false,
      DayPickerStrings: {
        months: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ],

        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'],

        days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],

        shortDays: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],

        goToToday: 'Hoy',
        prevMonthAriaLabel: 'Go to previous month',
        nextMonthAriaLabel: 'Go to next month',
        prevYearAriaLabel: 'Go to previous year',
        nextYearAriaLabel: 'Go to next year',
        isRequiredErrorMessage: 'Field is required.',
        invalidInputErrorMessage: 'Invalid date format.',
      },
      formatoFecha: '',
    };
  }

  componentDidMount() {  
  }

  dateEvent(date) {
    this.props.getDateSelected(date);
  }

  render() {
    return (
      <form>
        <div className="selectDate col-xs-12 col-sm-6 col-md-6 col-lg-6">        
          <DatePicker
            strings={this.state.DayPickerStrings}
            showGoToToday={false}
            onSelectDate={(date) => {
              this.dateEvent(date);
            }}
            underlined={false}
            minDate={new Date(new Date().getTime() - this.props.min * 86400000)}
            maxDate={new Date(new Date().getTime() + this.props.max * 86400000)}
            appearance="outline"
            allowTextInput={false}
            placeholder="Seleccione una fecha"
            isMonthPickerVisible={false}
            formatDate={(date) => {
              this.setState({ formatoFecha: moment(date).format('DD/MM/YYYY') });
            }}
          />
        </div>
        {this.props.showInput ? (
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <input className="inputDate" type="text" disabled={true} value={this.state.formatoFecha} />
          </div>
        ) : null}
      </form>
    );
  }
}


